<script setup lang="ts">
  import { computed, useId } from 'vue';
  import { spacingVars } from '@tundr/ds-foundations';
  import { dividerColorClass, dividerDirectionClass } from './Divider.css';
  import { DividerDirection, DividerVariant } from './Divider.types';
  import type { DividerProps } from './Divider.types';

  const props = withDefaults(defineProps<DividerProps>(), {
    variant: DividerVariant.LIGHT,
    direction: DividerDirection.HORIZONTAL,
  });

  const uid = useId();
  const resolvedTestId = computed(() => props.testId ?? `ds-divider-${uid}`);

  const marginValue = (value: number | undefined) =>
    value === undefined ? spacingVars.lg : `${value}px`;

  const styles = computed(() => {
    return {
      height: props.height !== undefined ? `${props.height}px` : undefined,
      width: props.width !== undefined ? `${props.width}px` : undefined,
      margin:
        props.direction === DividerDirection.VERTICAL
          ? `0px ${marginValue(props.horizontalMargin)}`
          : props.direction === DividerDirection.HORIZONTAL
            ? `${marginValue(props.verticalMargin)} 0px`
            : undefined,
    };
  });

  const dividerClasses = computed(() => {
    return `${dividerDirectionClass[props.direction]} ${
      dividerColorClass[props.variant]
    }`;
  });
</script>

<template>
  <div :class="dividerClasses" :style="styles" :data-testid="resolvedTestId" />
</template>
